module.exports = __webpack_public_path__ + "img/58.32a9f739.jpg";